const { gql } = require('graphql-tag');

const CartFragment = require('../fragments/defaultCart').fragment;

module.exports = gql`
  ${CartFragment}

  query getMyCart(
    $cartId: String!,
    $locale: Locale!,
    $acceptLanguage: [Locale!],
    $currency: Currency!,
    $storeKey: KeyReferenceInput!
  ) {
    inStore(key: $storeKey) {
      me {
        cart(id: $cartId) {
          ...DefaultCart
        }
      }
    }
  }
`;
